export interface LienReleaseRequest {
    index?: number;
    customerCode?: string;
    customerDesc?: string;
    customerLienId?: number;
    dateFrom?: string;
    dateTo?: string;
    deliveryMethod?: number;
    deliveryMethodDesc?: string;
    email?: string;
    jobSiteCode?: string;
    jobSiteDesc?: string;
    jobSiteName?: string;
    jobSiteAddress?: string;
    lienCode?: string;
    lienComments?: string;
    lienDate?: string;
    lienDateObj?: Date;
    lienStatus?: number;
    lienStatusDesc?: string;
    salesOfficeCode?: string;
    phone?: string;
    requestTypeCode?: number;
    requestTypeDesc?: string;
    requestedName?: string;
    reviewFlag?: boolean;
}

export interface LienReleaseRequestDTO {
    lienReleases?: Array<LienReleaseRequest>;
}
// ==========================================================================================================================
// Edit Lien Release
// ==========================================================================================================================

export interface LienReleaseRequestEdit {
    customerLienId: string;
    lienDate: string;
    lienCode: string;
    customerCode: string;
    customerDesc: string;
    jobSiteCode: string;
    jobSiteDesc: string;
    jobSiteName: string;
    jobSiteAddress: string;
    requestTypeCode: string;
    requestedName: string;
    dateFrom: string;
    dateTo: string;
    phone: string;
    email: string;
    deliveryMethod: string;
    reviewFlag: string;
    deliveryMethodDesc: string;
    requestTypeDesc: string;
    lienStatus: string;
    lienComments: string;
}

// ==========================================================================================================================
// List Lien Release
// ==========================================================================================================================

export interface LienReleaseExcel {
    countryCode?: string;
    customerCode?: string;
    dateFrom?: string;
    dateTo?: string;
    deliveryMethod?: string;
    deliveryMethodId?: number;
    email?: string;
    errorDescription?: string;
    isValid?: boolean;
    JobSiteAddress?: string;
    jobSiteCode?: string;
    jobSiteName?: string;
    lienComments?: string;
    phone?: string;
    requestType?: string;
    requestTypeId?: number;
    requestedName?: string;
}

export interface LienReleaseRequestList {
    lienReleases?: Array<LienReleaseExcel>;
    totalErrors?: string;
}

export interface LienReleaseRequestItemErrors {
    name?: string;
    description?: string;
}

//
// Create Lien Release
//

export interface LienReleaseRequestCreate {
    requestType: number;
    requestedName: string;
    dateFrom: string;
    dateTo: string;
    phone: string;
    email: string;
    lienComments: string;
    deliveryMethod: {
        deliveryMethodCode: number
    };
    country: {
        countryCode: string
    };
    customer: {
        customerCode: string
    };
    jobsite: {
        jobSiteCode: string,
        jobSiteName: string,
        jobSiteAddress: string
    };
}
